import { PresidentCard } from '@/core/blocks';
import { Carousel, CarouselContent, CarouselDots, CarouselItem } from '@/core/ui';
import type { IHistoryPresidents } from '@/types';
import { splitArray } from '@/utils';

export const PresidentList = ({ presidents }: { presidents: IHistoryPresidents['presidents'] }) => {
  if (presidents.length < 12) {
    return (
      <div className='grid grid-cols-6 gap-6'>
        {presidents.map((p) => (
          <PresidentCard
            presidentId={p.id}
            className='col-span-1'
            key={p.id}
            name={p.name}
            start_date={p.start_date}
            end_date={p.end_date}
            image={p.profile_image}
            link={p.has_details}
          />
        ))}
      </div>
    );
  }

  const list = splitArray(presidents, 12);

  return (
    <Carousel
      opts={{
        align: 'start',
        dragFree: true,
      }}
      orientation='vertical'
      className='w-full h-full max-w-full'
    >
      <CarouselContent className='mt-1 h-[650px] gap-6'>
        {list.map((items, index) => (
          <CarouselItem key={index} className='pt-0 basis-auto'>
            <div className='grid grid-cols-6 gap-6'>
              {items.map((p) => (
                <PresidentCard
                  presidentId={p.id}
                  className='col-span-1'
                  key={p.id}
                  name={p.name}
                  start_date={p.start_date}
                  end_date={p.end_date}
                  image={p.profile_image}
                  link={p.has_details}
                />
              ))}
            </div>
          </CarouselItem>
        ))}
      </CarouselContent>
      <CarouselDots />
    </Carousel>
  );
};
